module.exports = __webpack_public_path__ + "static/media/YM87_4.11093985.jpg";